<template>
  <v-main>
    <v-container fluid class="migrate-page pa-0">
      <section class="migrate-hero">
      <div class="decor decor--one"></div>
      <div class="decor decor--two"></div>
      <div class="decor decor--three"></div>

      <header class="hero-header">
        <img
          :src="require('@/assets/Logo_betask.png')"
          class="brand-logo"
          alt="BeTask"
        >
        <div class="announcement-badge">
          <span class="announcement-icon">
            <v-icon color="#0b4387" size="24">mdi-bullhorn-outline</v-icon>
          </span>
          <span>ประกาศสำคัญ</span>
        </div>
      </header>

      <template v-if="canMigrate">
        <div class="hero-content">
          <div class="hero-copy">
            <p class="eyebrow">BETASK SYSTEM UPDATE</p>
            <h1>
              มีการปรับเปลี่ยน
              <span>รูปแบบระบบใหม่</span>
            </h1>
            <p class="hero-subtitle">
              เพื่อความสะดวกและประสิทธิภาพในการใช้งานที่ดียิ่งขึ้น
            </p>
            <p class="hero-description">
              กรุณาตรวจสอบข้อมูลร้านและข้อมูลนัดหมายของคุณ
              พร้อมดำเนินการย้ายข้อมูลเข้าสู่ระบบใหม่
            </p>

            <div class="migration-notice">
              <div class="notice-summary">
                <span class="notice-icon">
                  <v-icon color="#3f8f3b" size="34">mdi-store-check-outline</v-icon>
                </span>
                <div>
                  <strong>โปรดยืนยันการย้ายข้อมูลภายในเวลาที่กำหนด</strong>
                  <p>
                    ตรวจสอบความถูกต้องของข้อมูลร้านก่อนเริ่มดำเนินการ
                    เพื่อให้การย้ายข้อมูลเป็นไปอย่างราบรื่น
                  </p>
                </div>
              </div>
              <div class="deadline">
                <v-icon color="#3f8f3b" size="34">mdi-calendar-month-outline</v-icon>
                <div>
                  <small>กรุณาดำเนินการภายในวันที่</small>
                  <strong>15 สิงหาคม 2569</strong>
                </div>
              </div>
            </div>

            <v-btn
              class="migrate-button"
              color="#0b4387"
              dark
              large
              :href="migrationUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-icon left size="25">mdi-login-variant</v-icon>
              ตรวจสอบและย้ายข้อมูลของคุณ
              <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>

            <p class="secure-note">
              <v-icon size="16" color="#66809f">mdi-lock</v-icon>
              ข้อมูลของคุณจะถูกย้ายอย่างปลอดภัย มั่นใจได้ 100%
            </p>
          </div>

          <div class="hero-visual" aria-hidden="true">
            <div class="visual-orbit visual-orbit--one"></div>
            <div class="visual-orbit visual-orbit--two"></div>
            <span class="visual-plus visual-plus--one">+</span>
            <span class="visual-plus visual-plus--two">+</span>
            <span class="visual-plus visual-plus--three">+</span>
            <img
              :src="require('@/assets/Mascot-Betask.png')"
              class="mascot"
              alt=""
            >
          </div>
        </div>

        <div class="feature-card">
          <div class="feature-heading">สิ่งที่คุณจะได้รับจากระบบใหม่</div>
          <div class="feature-list">
            <div class="feature-item">
              <span><v-icon color="#3f8f3b">mdi-clock-fast</v-icon></span>
              <div>
                <strong>ใช้งานง่าย</strong>
                <small>สะดวก รวดเร็วมากยิ่งขึ้น</small>
              </div>
            </div>
            <div class="feature-item">
              <span><v-icon color="#3f8f3b">mdi-shield-check-outline</v-icon></span>
              <div>
                <strong>ปลอดภัย</strong>
                <small>มาตรฐานความปลอดภัยที่เชื่อถือได้</small>
              </div>
            </div>
            <div class="feature-item">
              <span><v-icon color="#3f8f3b">mdi-devices</v-icon></span>
              <div>
                <strong>รองรับทุกอุปกรณ์</strong>
                <small>ใช้งานได้ทุกที่ ทุกเวลา</small>
              </div>
            </div>
            <div class="feature-item">
              <span><v-icon color="#3f8f3b">mdi-chart-box-outline</v-icon></span>
              <div>
                <strong>ฟีเจอร์ครบครัน</strong>
                <small>ตอบโจทย์ธุรกิจของคุณ</small>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div v-else class="state-layout">
        <div class="state-card">
          <div
            class="state-icon"
            :class="isAdmin ? 'state-icon--warning' : 'state-icon--danger'"
          >
            <v-icon :color="isAdmin ? '#e58b20' : '#d84a4a'" size="52">
              {{ isAdmin ? 'mdi-store-alert-outline' : 'mdi-lock-outline' }}
            </v-icon>
          </div>
          <p class="eyebrow">BETASK SYSTEM UPDATE</p>
          <h1 v-if="!isAdmin">ไม่มีสิทธิ์เข้าถึงฟีเจอร์นี้</h1>
          <h1 v-else>ร้านค้านี้ยังไม่สามารถย้ายข้อมูลได้</h1>
          <p v-if="!isAdmin" class="state-description">
            เฉพาะผู้ดูแลระบบ (admin) เท่านั้น
            ที่สามารถย้ายข้อมูลร้านและข้อมูลนัดหมายได้
          </p>
          <p v-else class="state-description">
            Shop ID ของร้านนี้ยังไม่อยู่ในรายชื่อร้านที่เปิดให้ย้ายข้อมูล
            หากต้องการความช่วยเหลือ กรุณาติดต่อทีมงาน BeTask
          </p>
        </div>
        <div class="state-mascot">
          <img :src="require('@/assets/Mascot-Betask.png')" alt="BeTask mascot">
        </div>
      </div>

        <footer class="support-footer">
          <span>
            <v-icon size="19" color="#0b4387">mdi-information-outline</v-icon>
            หากมีข้อสงสัยหรือต้องการความช่วยเหลือ สามารถติดต่อทีมงานได้ที่
          </span>
          <a
            class="support-link"
            href="https://lin.ee/pD0zBrD"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-icon size="21" color="#0b4387">mdi-headset</v-icon>
            ศูนย์ช่วยเหลือ
          </a>
          <span>พร้อมให้บริการทุกวัน 08:30 – 17:30 น.</span>
        </footer>
      </section>
    </v-container>
  </v-main>
</template>

<script>
const beautyActiveMigrationStatusShops = Object.freeze([
  { sourceShopId: 'U1cd407387672947111f5ca96ef30a481', shopName: 'Hollywoodlashesbkk' },
  { sourceShopId: 'Ufe85a0365d39673b5c938cbc0ff89e0f', shopName: 'ANIKA Hair Salon' },
  { sourceShopId: 'Uce186fab6183b2ef27783685ea7511db', shopName: 'Bangkok Lash Studio' },
  { sourceShopId: 'U811d6d1b5e535c0a238da4be7527a6dd', shopName: 'Browbabe bangkok' },
  { sourceShopId: 'U6d93c9d443ad9288c1aade03b7d55a1d', shopName: 'Frenchy Brows' },
  { sourceShopId: 'Ub57769aa3b5536231ae8c7ff5f4cab76', shopName: 'GentleCutz Studio' },
  { sourceShopId: 'U0648c2d9f07dbeeb4c3d6bf605010076', shopName: 'Hyang Gi Salon Thailand' },
  { sourceShopId: 'Uc83d38eca99d41e5614ba75d58b705d3', shopName: 'JaylyLashes' },
  { sourceShopId: 'U1a16c2cc8640b47e1db8d6661ef58868', shopName: 'Lash Room Bangkok' },
  { sourceShopId: 'Uae49536fd2fcc69bee9852e92db30098', shopName: 'Lash Secret' },
  { sourceShopId: 'U1df48c445028c6ad690028051fef80f4', shopName: 'lashbkk' },
  { sourceShopId: 'Ub6b12a6b5c6705114e9872da6ce3aad4', shopName: 'Lashes.in' },
  { sourceShopId: 'U13af8312b10c59152271ed083d6f4910', shopName: 'Mamind Studio' },
  { sourceShopId: 'Uac75a61fda354308fcf380a974ba07e0', shopName: 'Ssweetly studio' },
  { sourceShopId: 'U45a6db8182b71d233bfdc9540d0b908d', shopName: 'The barber box & The barber BOY' },
  { sourceShopId: 'U64c445c27b4d59c52a3430973a83378f', shopName: 'THE LEB LAB' },
  { sourceShopId: 'U40dd74fae66b6f7bde42428f4aa7720b', shopName: 'Wink Wink Nail' },
  { sourceShopId: 'U0645d90fd374e01454683ab2ff3d5b14', shopName: 'ขนตางอน' },
  { sourceShopId: 'Ubb4bade0d5be45a9385f8c403c33915d', shopName: 'Gentleman barber' },
  { sourceShopId: 'U4cabb94f18f7738784f613fe301fbffd', shopName: 'Patsara Studio' },
  { sourceShopId: 'Ucc2914e1a3e45c5f7df76f48d58020c9', shopName: 'Fon nail เพ้นท์เล็บเมเจอร์รังสิต' },
  { sourceShopId: 'U6bf55720d3b7e154b4846eac91456b70', shopName: 'nicehair.chiangmai' },
  { sourceShopId: 'U70a2240c4dd7b289bc578b8d1f0d64d3', shopName: 'Lash Affair' },
  { sourceShopId: 'U0a3ba4917f2ed504dc9a9ac3f414d071', shopName: 'Defined Beauty Studio' },
  { sourceShopId: 'U8c0f7033cef74fa39c8ee4f7c2b89164', shopName: 'Barbie\'s lab' },
  { sourceShopId: 'U0388e17334a89faf70fe895d07280788', shopName: 'Blackstore' },
  { sourceShopId: 'Ua578f9c2fb5b8501468af34926821d0c', shopName: 'สตอรี่ คัท จำกัด' },
  { sourceShopId: 'U7def03a071ee547ac2f647e73d5cc5ca', shopName: 'love Lashes' },
  { sourceShopId: 'Ua79577028d78e44a7cbd6f0525094bc3', shopName: 'Yopanglashes' },
  { sourceShopId: 'Ube04a4d1e6c417e6ba51d1ad20583052', shopName: 'Monday Nail Studio' },
  { sourceShopId: 'Ud3669692fa1feff1a33aff291fb9d6a0', shopName: 'Studio Mist' },
  { sourceShopId: 'Uca36f9c8741267f666cd9594dd51fb18', shopName: 'Alkesa Hair Studio' },
  { sourceShopId: 'U3bfe884ceef1e9eb7a726e8e41a5c98e', shopName: 'ADAM BARBER SHOP' },
  { sourceShopId: 'U5e41afa24ddeeb256e34de5bc8a3b88d', shopName: 'Marci Studio (Parc Bangna)' },
  { sourceShopId: 'U4d99aee2fbd59fe056e8f6c2bd4809a6', shopName: 'Bijin House Salon' },
  { sourceShopId: 'U2cac12d7a6f7fe5c2fdaa92fa0f96fb3', shopName: 'Blink Glam & PhiPraw' },
  { sourceShopId: 'U18b1b068f71b1f9d14face443c22f970', shopName: 'BARBERSHOP AMEYOKO' },
  { sourceShopId: 'U8a98b16a69ca754eae54e7185fefe325', shopName: 'ร้านตัดผมชาย SO CUT ตลาดโอโซนวัน' },
  { sourceShopId: 'Uf15f54316bf1dffb24aab5fee9a1685b', shopName: 'ami b by vanilla beauty' },
  { sourceShopId: 'Uff1f2e601533e8ef5444492048304d8a', shopName: 'AING RENEW SKIN' },
  { sourceShopId: 'U5d8e88d6287a2bd447cb0e6b21439a12', shopName: 'Highboiibarber&salon' },
  { sourceShopId: 'U8d639443c0a1de4bbfa1c4977527c7bb', shopName: 'Daddy boy' },
  { sourceShopId: 'U7128b04b822fa773aa3209cc5b77661a', shopName: 'Vanilla studio' },
  { sourceShopId: 'SD_1745831868530', shopName: 'Lasholic.bkk' },
  { sourceShopId: 'Ub39f8cdb604e2cfc335ff4d09e9260f0', shopName: 'Flowhair house' },
  { sourceShopId: 'U1d9dad7fb58522511fe6b6bbf8587f12', shopName: 'Narunlashes' }
])

export default {
  name: 'MigrateShop',
  data () {
    return {
      session: this.$session.getAll(),
      migrationShops: beautyActiveMigrationStatusShops
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  computed: {
    sessionData () {
      return this.session.data || {}
    },
    isAdmin () {
      return this.sessionData.USER_ROLE === 'admin'
    },
    currentMigrationShop () {
      const shopId = String(this.sessionData.shopId || '')
      return this.migrationShops.find(shop => shop.sourceShopId === shopId)
    },
    isShopAllowed () {
      return Boolean(this.currentMigrationShop)
    },
    canMigrate () {
      return this.isAdmin && this.isShopAllowed
    },
    migrationUrl () {
      const shopId = encodeURIComponent(String(this.sessionData.shopId || ''))
      const userId = encodeURIComponent(String(this.sessionData.userId || ''))
      return `https://belink-migrate-management.betaskthai.tech/migrate/init?shopId=${shopId}&userId=${userId}`
    }
  }
}
</script>

<style scoped>
.migrate-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 64px);
  padding: 24px !important;
  font-family: 'Kanit', sans-serif;
  background:
    radial-gradient(circle at 8% 10%, rgba(100, 208, 225, 0.22), transparent 24%),
    radial-gradient(circle at 92% 90%, rgba(105, 200, 220, 0.20), transparent 22%),
    linear-gradient(145deg, #f5fbff 0%, #ffffff 45%, #f3fbfd 100%);
}

.migrate-hero {
  position: relative;
  width: 100%;
  max-width: 1440px;
  min-height: 0;
  margin: 0 auto;
  padding: 38px 48px 0;
  overflow: hidden;
  color: #17324f;
  background:
    linear-gradient(120deg, rgba(255, 255, 255, 0.98) 0%, rgba(246, 251, 255, 0.96) 56%, rgba(220, 242, 252, 0.9) 100%);
  border: 1px solid rgba(158, 198, 221, 0.35);
  border-radius: 28px;
  box-shadow: 0 22px 65px rgba(31, 82, 120, 0.13);
}

.migrate-hero::before {
  position: absolute;
  top: -150px;
  right: -130px;
  width: 560px;
  height: 560px;
  content: '';
  background: rgba(170, 222, 243, 0.34);
  border-radius: 50%;
}

.hero-header {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.brand-logo {
  display: block;
  width: 145px;
  height: auto;
  object-fit: contain;
}

.announcement-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 16px 6px 7px;
  color: #fff;
  font-size: 17px;
  font-weight: 500;
  background: #0b4387;
  border-radius: 999px;
  box-shadow: 0 8px 18px rgba(11, 67, 135, 0.18);
}

.announcement-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  margin-right: 10px;
  background: #fff;
  border-radius: 50%;
}

.hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
}

.hero-copy {
  position: relative;
  z-index: 2;
  flex: 0 0 68%;
  max-width: 820px;
  padding: 26px 0 22px;
}

.eyebrow {
  margin: 0 0 10px;
  color: #5593bd;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2.4px;
}

.hero-copy h1,
.state-card h1 {
  margin: 0;
  color: #0a3d78;
  font-size: clamp(34px, 4vw, 58px);
  font-weight: 600;
  line-height: 1.13;
  letter-spacing: -1.2px;
}

.hero-copy h1 span {
  display: block;
}

.hero-subtitle {
  margin: 12px 0 8px;
  color: #18558f;
  font-size: clamp(18px, 2vw, 25px);
  font-weight: 500;
}

.hero-description {
  max-width: 610px;
  margin: 0 0 22px;
  color: #5c6f82;
  font-size: 16px;
  line-height: 1.7;
}

.migration-notice {
  display: flex;
  align-items: stretch;
  width: 100%;
  margin-bottom: 18px;
  padding: 14px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #e3eef4;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(33, 83, 117, 0.08);
}

.notice-summary {
  display: flex;
  flex: 1;
  align-items: center;
  padding: 2px 16px 2px 2px;
}

.notice-icon {
  display: inline-flex;
  flex: 0 0 58px;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  margin-right: 13px;
  background: #eef8ed;
  border-radius: 50%;
}

.notice-summary strong {
  color: #274967;
  font-size: 14px;
  font-weight: 500;
}

.notice-summary p {
  margin: 3px 0 0;
  color: #718295;
  font-size: 12px;
  line-height: 1.45;
}

.deadline {
  display: flex;
  flex: 0 0 245px;
  align-items: center;
  padding: 9px 14px;
  color: #366f32;
  background: linear-gradient(135deg, #f0faee, #e4f5e1);
  border-radius: 12px;
}

.deadline .v-icon {
  margin-right: 10px;
}

.deadline small,
.deadline strong {
  display: block;
}

.deadline small {
  margin-bottom: 1px;
  color: #5d7760;
  font-size: 11px;
}

.deadline strong {
  font-size: 20px;
  font-weight: 600;
}

.migrate-button {
  min-width: 360px !important;
  height: 56px !important;
  padding: 0 24px !important;
  color: #fff !important;
  font-size: 17px !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 22px rgba(11, 67, 135, 0.23) !important;
}

.secure-note {
  display: flex;
  align-items: center;
  margin: 10px 0 0 10px;
  color: #74879a;
  font-size: 11px;
}

.secure-note .v-icon {
  margin-right: 5px;
}

.hero-visual {
  position: absolute;
  z-index: 1;
  top: 38px;
  right: 3%;
  width: 36%;
  max-width: 450px;
  height: 510px;
}

.mascot {
  position: absolute;
  z-index: 2;
  right: 6%;
  bottom: 0;
  width: 72%;
  max-height: 470px;
  object-fit: contain;
  filter: drop-shadow(0 22px 22px rgba(40, 84, 116, 0.18));
}

.visual-orbit {
  position: absolute;
  border: 2px solid rgba(82, 174, 215, 0.25);
  border-radius: 50%;
}

.visual-orbit--one {
  top: 12%;
  right: -6%;
  width: 340px;
  height: 340px;
}

.visual-orbit--two {
  top: 23%;
  right: 8%;
  width: 245px;
  height: 245px;
}

.visual-plus {
  position: absolute;
  z-index: 3;
  color: #57afd4;
  font-size: 34px;
  font-weight: 500;
}

.visual-plus--one {
  top: 16%;
  left: 1%;
}

.visual-plus--two {
  top: 28%;
  right: 2%;
  color: #75bb46;
}

.visual-plus--three {
  top: 8%;
  right: 26%;
  font-size: 25px;
}

.feature-card {
  position: relative;
  z-index: 4;
  display: flex;
  align-items: center;
  margin: 0 0 24px;
  padding: 16px 22px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e1edf4;
  border-radius: 16px;
  box-shadow: 0 10px 26px rgba(33, 83, 117, 0.1);
}

.feature-heading {
  flex: 0 0 180px;
  padding-right: 20px;
  color: #154d7d;
  font-size: 14px;
  font-weight: 500;
  border-right: 1px solid #e3edf2;
}

.feature-list {
  display: flex;
  flex: 1;
  align-items: stretch;
}

.feature-item {
  display: flex;
  flex: 1;
  align-items: center;
  padding: 0 12px;
}

.feature-item > span {
  display: inline-flex;
  flex: 0 0 42px;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-right: 9px;
  background: #eef8ed;
  border-radius: 50%;
}

.feature-item strong,
.feature-item small {
  display: block;
}

.feature-item strong {
  color: #315471;
  font-size: 12px;
  font-weight: 500;
}

.feature-item small {
  margin-top: 2px;
  color: #7a8a97;
  font-size: 10px;
  line-height: 1.35;
}

.support-footer {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  margin: 0 -48px;
  padding: 12px 30px;
  color: #6e8090;
  font-size: 12px;
  background: rgba(234, 245, 251, 0.78);
  border-top: 1px solid rgba(202, 223, 235, 0.7);
}

.support-footer span,
.support-link {
  display: inline-flex;
  align-items: center;
}

.support-link {
  margin: 0 14px;
  color: #0b4387 !important;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.support-link:hover {
  opacity: 0.72;
}

.support-footer .v-icon {
  margin-right: 6px;
}

.state-layout {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 560px;
}

.state-card {
  z-index: 2;
  width: 620px;
  padding: 50px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #e2edf4;
  border-radius: 24px;
  box-shadow: 0 18px 45px rgba(31, 82, 120, 0.12);
}

.state-card h1 {
  font-size: clamp(30px, 3vw, 45px);
}

.state-description {
  max-width: 510px;
  margin: 16px 0 0;
  color: #63778a;
  font-size: 16px;
  line-height: 1.7;
}

.state-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 90px;
  margin-bottom: 24px;
  border-radius: 50%;
}

.state-icon--danger {
  background: #fff0f0;
}

.state-icon--warning {
  background: #fff6e8;
}

.state-mascot {
  z-index: 1;
  width: 330px;
  margin-left: -35px;
}

.state-mascot img {
  display: block;
  width: 100%;
  filter: drop-shadow(0 18px 18px rgba(40, 84, 116, 0.16));
}

.decor {
  position: absolute;
  pointer-events: none;
  border: 1px solid rgba(71, 164, 205, 0.18);
  border-radius: 50%;
}

.decor--one {
  bottom: 80px;
  left: -90px;
  width: 180px;
  height: 180px;
}

.decor--two {
  bottom: 135px;
  left: -55px;
  width: 110px;
  height: 110px;
}

.decor--three {
  top: 40%;
  right: -40px;
  width: 100px;
  height: 100px;
}

@media (max-width: 1260px) {
  .hero-copy {
    flex-basis: 72%;
  }

  .hero-visual {
    right: 0;
    width: 34%;
  }

  .feature-card {
    align-items: flex-start;
  }

  .feature-list {
    flex-wrap: wrap;
  }

  .feature-item {
    flex: 0 0 50%;
    margin: 5px 0;
  }
}

@media (max-width: 960px) {
  .migrate-page {
    padding: 16px !important;
  }

  .migrate-hero {
    min-height: 0;
    padding: 28px 28px 0;
  }

  .hero-copy {
    flex-basis: 75%;
  }

  .hero-visual {
    right: -8%;
    width: 42%;
    opacity: 0.68;
  }

  .migration-notice {
    display: block;
  }

  .deadline {
    width: 100%;
    margin-top: 10px;
  }

  .feature-card {
    display: block;
  }

  .feature-heading {
    padding: 0 0 12px;
    border-right: 0;
    border-bottom: 1px solid #e3edf2;
  }

  .feature-list {
    margin-top: 10px;
  }

  .support-footer {
    flex-wrap: wrap;
    margin: 0 -28px;
    text-align: center;
  }

  .state-mascot {
    width: 260px;
  }
}

@media (max-width: 720px) {
  .migrate-page {
    display: block;
    padding: 0 !important;
  }

  .migrate-hero {
    min-height: 100vh;
    padding: 24px 18px 0;
    border: 0;
    border-radius: 0;
  }

  .brand-logo {
    width: 115px;
  }

  .announcement-badge {
    padding-right: 12px;
    font-size: 14px;
  }

  .announcement-icon {
    width: 32px;
    height: 32px;
    margin-right: 7px;
  }

  .hero-content {
    display: block;
  }

  .hero-copy {
    max-width: none;
    padding-top: 200px;
  }

  .hero-copy h1 {
    font-size: 34px;
    letter-spacing: -0.5px;
  }

  .hero-visual {
    top: 72px;
    right: 50%;
    width: 225px;
    height: 220px;
    opacity: 1;
    transform: translateX(50%);
  }

  .mascot {
    right: 25%;
    width: 50%;
    max-height: 215px;
  }

  .visual-orbit--one {
    width: 190px;
    height: 190px;
  }

  .visual-orbit--two {
    width: 130px;
    height: 130px;
  }

  .migration-notice {
    padding: 11px;
  }

  .notice-summary {
    align-items: flex-start;
    padding-right: 0;
  }

  .notice-icon {
    flex-basis: 48px;
    width: 48px;
    height: 48px;
  }

  .deadline {
    flex-basis: auto;
  }

  .migrate-button {
    width: 100%;
    min-width: 0 !important;
    padding: 0 14px !important;
    font-size: 15px !important;
  }

  .feature-card {
    padding: 16px 14px;
  }

  .feature-item {
    flex: 0 0 100%;
    padding: 6px 0;
  }

  .support-footer {
    display: block;
    margin: 0 -18px;
    padding: 14px 18px;
  }

  .support-footer span,
  .support-link {
    justify-content: center;
    width: 100%;
  }

  .support-link {
    margin: 7px 0;
  }

  .state-layout {
    display: block;
    min-height: 620px;
    padding-top: 200px;
  }

  .state-card {
    width: 100%;
    padding: 30px 24px;
  }

  .state-mascot {
    position: absolute;
    top: 0;
    right: 50%;
    width: 150px;
    margin: 0;
    transform: translateX(50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/System/MigrateShop.vue